import React from "react";

// Custom hand-drawn Coly wordmark.
// The source PNG is white text on black background.
// We use CSS mask-image so we can render it in any brand color (or white).
const WORDMARK_URL =
  "https://customer-assets.emergentagent.com/job_coly-coming-soon/artifacts/zl4jh2z6_Coly.png";

const Wordmark = ({
  color = "#3F7556",
  height = 28,
  inline = false,
  className = "",
  style = {},
  ...rest
}) => {
  // When `inline` is true, the wordmark scales with the surrounding font-size
  // using `em` units. Otherwise a fixed pixel height is used.
  const sizeStyle = inline
    ? { height: "1em", width: "2em", verticalAlign: "-0.15em" }
    : { height: `${height}px`, width: `${height * 2}px` };

  return (
    <span
      role="img"
      aria-label="Coly"
      className={`inline-block align-middle ${className}`}
      style={{
        ...sizeStyle,
        backgroundColor: color,
        WebkitMaskImage: `url("${WORDMARK_URL}")`,
        maskImage: `url("${WORDMARK_URL}")`,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        ...style,
      }}
      {...rest}
    />
  );
};

export default Wordmark;
